<template>
  <main>
    <div class="box">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: './' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: './order_list' }">订单列表</el-breadcrumb-item>
        <el-breadcrumb-item>订单详情</el-breadcrumb-item>
      </el-breadcrumb>
      <section class="detail">
        <h3>订单详情</h3>
        <ul>
          <li><span>订单号：</span><b class="main">{{ info.OrderNO }}</b></li>
          <li><span>订单状态：</span><b>{{ info.isPaid | getPaidDesc }}</b></li>
          <li><span>联系人：</span><b>{{ info.CustomerName }}</b></li>
          <li><span>联系电话：</span><b>{{ info.Moblie }}</b></li>
          <li><span>创建时间：</span><b>{{ info.created_at }}</b></li>
          <!-- <li><span>支付时间：</span><b>2020-07-16 14:39:16</b></li> -->
          <li><span>出行日期：</span><b class="bold">{{ info.UserDateTime }}</b></li>
          <!-- <li><span>快递单号：</span><b>W2020001325</b></li> -->
          <!-- <li><span>备注：</span><b>--</b></li> -->
        </ul>
        <el-table :data="table">
          <el-table-column prop="ProductName" label="产品名称"></el-table-column>
          <el-table-column prop="visa_order_package.VisaPriceName" label="套餐选择"></el-table-column>
          <el-table-column align="center" prop="KindName" label="签证类别"></el-table-column>
          <el-table-column align="center" prop="FormName" label="签证形式"></el-table-column>
          <el-table-column align="center" prop="visa_order_package.quantity" label="办理人数"></el-table-column>
          <el-table-column align="center" label="价格">
            <template slot-scope="s">
              <span class="bold">{{ s.row.visa_order_package.unitPrice }}</span>
            </template>
          </el-table-column>
        </el-table>
        <template v-if="info.visa_order_ins">
          <h3>保险：</h3>
          <ul>
            <li><span>保险名称：</span><b>{{ info.visa_order_ins.InsName }}</b></li>
            <li><span>保障期限：</span><b class="bold">{{ info | getInsDate }}</b></li>
            <li><span>单价：</span><b class="strong">{{ info.visa_order_ins.InsPrice }}</b></li>
            <li><span>数量：</span><b>{{ info.visa_order_ins.BuyNums }}</b></li>
            <li class="max"><span>说明：</span><b class="desc">{{ info.visa_order_ins.InsDesc }}</b></li>
          </ul>
        </template>
        <template v-for="v in info.express_deliverys" v-if="info.express_deliverys">
          <h3 :key="v.class_id">{{ v.class_id === 165 ? '签证邮寄' : '签证回邮' }}</h3>
          <ul :key="v.id">
            <li><span>姓名：</span><b>{{ v.m_contact_name || v.r_contact_name }}</b></li>
            <li><span>手机号：</span><b>{{ v.m_contact_tel || v.r_contact_tel }}</b></li>
            <li><span>地址：</span><b>{{ v | getAddress }}</b></li>
          </ul>
        </template>

        <div class="price">
          <div class="link"><router-link :to="{ name: 'order_pay', query: { orderNo: info.OrderNO } }"
              v-if="info.isPaid !== 1">去支付</router-link></div>
          <p><span>实付金额：</span><b>{{ info.total_amount }}</b></p>
        </div>
      </section>
    </div>
  </main>
</template>

<script>
import $visa from '@api/visa';
export default {
  components: {
  },
  data() {
    return {
      info: {
        visa_order_ins: {}
      },
      table: []
    }
  },
  created() {
    const { OrderNO } = this.$route.query;
    if (!OrderNO) {
      this.$router.push({ name: 'order_list' });
      return;
    }
    this.getDetail(OrderNO);
  },
  filters: {
    getInsDate(info) {
      const { BeginDate, EndDate } = info.visa_order_ins;
      return `${BeginDate} ~ ${EndDate}`;
    },
    getPaidDesc(type) {
      const desc = ['待付款', '已付款', '部分付款'];
      return desc[type] || type || null;
    },
    getAddress(item) {
      const {
        class_id,
        m_pro, m_city, m_area, m_address,
        r_pro, r_city, r_area, r_address
      } = item;
      return `${class_id === 165 ? m_pro + m_city + m_area + m_address : r_pro + r_city + r_area + r_address}`
    }
  },
  methods: {
    getDetail(OrderNO) {
      $visa.detail(OrderNO).then(res => {
        this.info = res;
        this.table = [res];
      })
    }
  }
}
</script>

<style scoped src="./detail.css"></style>